
import { useState } from "react";
import SearchBar from "@/pages/learn/components/SearchBar";
import ResourceGrid from "@/pages/learn/components/ResourceGrid";
import CategoryTabs from "@/pages/learn/components/CategoryTabs";
import { resources, categories } from "@/pages/learn/data/resources";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getArticleBySlugSync } from "@/utils/articleQueries";

const LearnContent = () => {
  const [searchQuery, setSearchQuery] = useState("");
  
  const filteredResources = resources.filter(resource => 
    (resource.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    resource.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
    resource.category.toLowerCase().includes(searchQuery.toLowerCase())) &&
    resource.category !== "Interviews (Coming Soon)"
  );

  // Find the featured article - now looking for ads-ranking
  const featuredArticle = getArticleBySlugSync("ads-ranking");
  
  console.log("Featured article:", featuredArticle);
  console.log("Featured article image:", featuredArticle?.images?.image2);

  return (
    <main className="flex-grow py-8 md:py-12">
      <div className="container">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold mb-2">ML System Design Resources</h1>
            <p className="text-muted-foreground">Expert-curated content to help you master ML system design</p>
          </div>
          
          <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        </div>
        
        {/* Featured Article */}
        <div className="mb-8 p-6 bg-card rounded-lg border shadow-sm">
          <h2 className="text-2xl font-semibold mb-3">Featured Article</h2>
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div className="md:w-1/2">
              <h3 className="text-xl font-medium mb-2">{featuredArticle?.title || "In-session Adaptation via User Behaviour Sequence Modelling"}</h3>
              <p className="text-muted-foreground mb-4">{featuredArticle?.description || "Learn about in-session adaptation techniques through user behavior sequence modeling for recommendation systems."}</p>
              <Link to={`/articles/${featuredArticle?.slug || "user-behaviour-sequence-modelling"}`}>
                <Button variant="default">
                  Read Article <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </div>
            <div className="md:w-1/2 rounded-md overflow-hidden shadow-sm">
              {featuredArticle?.images?.image2 ? (
                <img 
                  src={featuredArticle.images.image2} 
                  alt={featuredArticle.title} 
                  className="w-full h-auto object-cover"
                />
              ) : (
                <img 
                  src="https://res.cloudinary.com/dvxgyuvxl/image/upload/v1746997050/kuaishou_t30vr7.png" 
                  alt="In-session adaptation" 
                  className="w-full h-auto object-cover"
                />
              )}
            </div>
          </div>
        </div>
        
        <CategoryTabs 
          categories={categories} 
          filteredResources={filteredResources} 
        />
      </div>
    </main>
  );
};

export default LearnContent;
